import {ElementoRMLRecord} from "./ElementoRMLRecord";
import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import {ObjectFactory} from "@commons/types";

export type ElementoRMLXTabellaFormData = {
    readonly idAzienda: number,
    readonly idTipo: number,
    readonly codice: string,
    sortOrder: number,
    codElemento: string | null,
    elementoRML?: ElementoRMLRecord | null,
    descrizione?: string,
    elementoDiscrezionale?: boolean | string | null,
    elementoDiscrezionaleDefault: boolean | string | null,
}

export const factory: ObjectFactory<ElementoRMLXTabellaRecord> = (json?) => {
    return {
        idAzienda: (json && json.idAzienda) ? json.idAzienda : 0,
        idTipo: (json && json.idTipo) ? json.idTipo : 0,
        codice: (json && json.codice) ? json.codice : "",

        sortOrder: 0,
        codElemento: null,
        elementoDiscrezionale: 'null',
        elementoDiscrezionaleDefault: 'null',

        URI: null,
    };
}

export type ElementoRMLXTabellaRecord = ElementoRMLXTabellaFormData & URIAndTrace;
export type Type = ElementoRMLXTabellaRecord;
